export default __webpack_public_path__ + "static/bwp-social-share-793dca5e7e85bcccc3cb1d463ea64929.jpg";